define('container/argResolvers/ServiceArgResolver',['underscore'], function(_) {

    'use strict';

    function ServiceArgResolver() {
    }

    ServiceArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substring(0, 1) === '@';
    };

    ServiceArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {
        var parts = argDefinition.substring(1).split('.');

        return extensionApi.container.get(parts[0]).then(function(service) {
            return _.reduce(_.tail(parts), function(memo, key) {
                return memo[key];
            }, service);
        });
    };

    return ServiceArgResolver;
});

